var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"event"},[_c('mj-event-navigation',{staticClass:"mb-8"}),_c('transition',{attrs:{"name":"slide-left","mode":"out-in"}},[_c('keep-alive',[_c('router-view',{key:_vm.$route.fullPath})],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }